import type React from 'react';

import { Box, Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { themeColors } from '@/config/theme/themeColors.ts';
import { TOP_BAR_HEIGHT } from '@/layouts/private/topBar/TopBar.styles.ts';

export const PageLoading: React.FC = () => {
  return (
    <Stack
      sx={{
        alignContent: 'center',
        height: `calc(100vh - ${TOP_BAR_HEIGHT}px)`,
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Box sx={{ margin: 'auto' }}>
        <CircularProgress size="80px" sx={{ color: themeColors.turquoiseBlue }} />
      </Box>
    </Stack>
  );
};
